import { Popconfirm } from 'antd';
import { FC } from 'react';
import { PopconfirmProps } from 'antd/lib/popconfirm';

export const ILSPopconfirm: FC<PopconfirmProps> = (props) => {
  return <Popconfirm {...props} />;
};
